// routes.ts

import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { NamertuneComponent } from './Dashboard/namertune/namertune.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadComponent: () =>
      import('../app/Common/login/login.component').then((m) => m.LoginComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('../app/Dashboard/home/home.component').then((m) => m.HomeComponent),
    canActivate: [AuthGuard],
  },
  { path: 'namertune', component: NamertuneComponent },
  { path: '**', redirectTo: 'login' },
];
